import axios from "axios";
import {API_URL} from "../config";

export const storeUserService = async (values) => {
    return axios.post(`${API_URL}/users`, {...values});
};

export const updateUserService = async (id, values) => {
    return axios.put(`${API_URL}/users/${id}`, {...values});
};

export const getUserService = async (id) => {
    return axios.get(`${API_URL}/users/${id}`);
}
